module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAYCAYAAACSuF9OAAAAAXNSR0IArs4c6QAAAE5JREFUSA3tlEEKACAMw5z//7MOP1CKCAXT6y4hg9TqjaDNIJaDAlDaR+DBwH8G6nWpq+doJYzKVpwhBcwdAxi4NWCX2i2vCxjXIYDUCzd2tQwSAQ1QvQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/channelIcon.png
// module id = 780
// module chunks = 0